class LoyaltyProgress extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.waitForLoyaltyLion = this.waitForLoyaltyLion.bind(this)

    // Wait for loyaltylion to be available before refreshing
    this.waitForLoyaltyLionObject()
      .then(() => {
        window.loyaltylion.ui.refresh()
        return this.waitForLoyaltyLion()
      })
      .then(() => {
        const tierTotal = this.tierTotal
        this.tierTotal = tierTotal
      })
      .catch(error => {
        console.error('Error initializing LoyaltyLion:', error)
      })
  }

  async waitForLoyaltyLionObject (maxAttempts = 20) {
    for (let i = 0; i < maxAttempts; i++) {
      if (window.loyaltylion?.ui?.refresh) {
        return true
      }
      await new Promise(resolve => setTimeout(resolve, 100))
    }
    throw new Error('LoyaltyLion object not available after maximum attempts')
  }

  async waitForLoyaltyLion (maxAttempts = 20) {
    for (let i = 0; i < maxAttempts; i++) {
      if (!isNaN(this.tierTotal)) {
        return true
      }
      await new Promise(resolve => setTimeout(resolve, 100))
    }
    throw new Error('LoyaltyLion failed to load after maximum attempts')
  }

  get tierTotal () {
    return parseInt(
      this.querySelector('.lion-tier-progress__tier-value')?.textContent,
    )
  }

  get tierLowerBound () {
    return this.querySelector('.lion-tier-progress__tier-bound')?.children[0]
      .textContent
  }

  get tierUpperBound () {
    return this.querySelector('.lion-tier-progress__tier-bound')?.children[1]
      .textContent
  }

  set tierTotal (value) {
    const progressValue = value - this.tierLowerBound
    const progressDiff = this.tierUpperBound - this.tierLowerBound
    const progressToNext = this.tierUpperBound - value
    const progress = (progressValue / progressDiff) * 100
    const width =
      progress +
      (this.els.bar.element.dataset.width / this.tierUpperBound) * 100

    this.els.progress.element.style.setProperty(
      '--Current_progress',
      `${progress}%`,
    )
    this.els.bar.element.style.width = `${width}%`

    if (this.els.title) {
      this.els.title.element.textContent = this.els.title.element.dataset.string.replace(
        '[points_to_tier]',
        progressToNext,
      )
    }
  }
}

if (!customElements.get('loyalty-progress')) {
  customElements.define('loyalty-progress', LoyaltyProgress)
}
